import { OfficerService } from '@services';
import reduxHelpers from '@redux-core/helpers';
import Actions from '.';

/* ------------- Thunks actions ------------- */
export const getById = (id) => ((dispatch) => {
	dispatch(Actions.updateLoaders('activeOfficer', true));

	OfficerService.getById(id, { includeStats : true })
		.then(({ data }) => {
			dispatch(Actions.receiveData([{ property : 'activeOfficer', value : data }]));
			dispatch(Actions.updateLoaders('activeOfficer', false));
		})
		.catch((error) => {
			reduxHelpers.apiErrorHandler({
				dispatch,
				module         : 'officers',
				property       : 'loaders.activeOfficer',
				defaultMessage : 'Error loading officer',
			})(error);
		});
});

export default {
	getById,
};
